import React, {useContext, useState} from "react";
import {TextField} from "@mui/material";
import {withStyles} from "@mui/styles";
import {useIntl, FormattedMessage} from "react-intl";
import filterMenuStyle from "assets/jss/components/filterMenuStyle";
import {FilterContext, FilterDispatchContext} from "contexts/filterContext";

// Free numeric inputs validated together (the Price and Sales tabs). Each item
// is one filter with a fixed id, so a re-validation replaces the previous chip
// (filter_set) and an emptied input drops its filter.
function ValueFiltersPanel({classes, items, applyLabelId}) {
    const intl = useIntl();
    const dispatch = useContext(FilterDispatchContext);
    const {filters} = useContext(FilterContext);

    // seeded from the active filters so reopening the tab shows the applied values
    const [inputs, setInputs] = useState(() => {
        const initial = {};
        items.forEach(({id}) => {
            const active = filters.find((filter) => filter.id === id);
            initial[id] = active ? String(active.value) : "";
        });

        return initial;
    });

    const handleApply = () => {
        items.forEach(({"@type": type, id}) => {
            const raw = inputs[id];

            if ("" === raw || null === raw || isNaN(Number(raw))) {
                // an emptied input drops its filter (nothing to drop: no dispatch,
                // an untouched filters identity avoids a pointless list reload)
                if (filters.some((filter) => filter.id === id)) {
                    dispatch({type: "filter_remove", item: {id}});
                }

                return;
            }

            dispatch({type: "filter_set", item: {"@type": type, id, value: Number(raw)}});
        });
    };

    return (
        <div className={classes.priceFilters}>
            {items.map(({id, unit, labelId}) => (
                <div className={classes.filterInColumn} key={id}>
                    <span className={classes.filterBlueTitle}>
                        {intl.formatMessage({id: labelId}) + (unit ? ` (${unit})` : "")}
                    </span>
                    <TextField
                        type="number"
                        value={inputs[id]}
                        onChange={(event) => setInputs({...inputs, [id]: event.target.value})}
                        onKeyDown={(event) => {
                            if ("Enter" === event.key) {
                                handleApply();
                            }
                        }}
                        variant="outlined"
                        size="small"
                        className={classes.priceFilterInput}
                        inputProps={{min: 0}}
                    />
                </div>
            ))}
            <button type="button" onClick={handleApply} className={classes.priceFilterApply}>
                <FormattedMessage id={applyLabelId}/>
            </button>
        </div>
    );
}

export default withStyles(filterMenuStyle)(ValueFiltersPanel);
